import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


import { AuthService } from './auth.service';
import { LoadinService } from 'app/core/services/loadin.service';
import { SweetAlertService } from 'app/core/services/sweet-alert.service';


@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private spinnerService: LoadinService,
    private sweetAlertService: SweetAlertService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.spinnerService.requestStart()
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 0 && err.error instanceof ProgressEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        this.spinnerService.requestEnded()
        this.sweetAlertService.basicWarning('Ops! Verifier votre connexion.')
  
      }
      if (err.status === 401) {
        this.spinnerService.requestEnded()


        // auto logout if 401 response returned from api
        this.authService.logout();
        // location.reload();
      }
      this.spinnerService.requestEnded()


      const error = err.error.message || err.statusText;
      return throwError(error)
    }));
  }
}
